import {useContext} from 'react';
import {useRouteMatch} from 'react-router-dom';
import {AffiliationType} from '../../../../../../backend/enums/affiliation-type';
import {InviteSenderType} from '../../../../../../backend/enums/invite-sender-type';
import {ProfessionalCaregiverInviteForm} from '../../../../../../components/professional-caregiver-invite-form/professional-caregiver-invite-form';
import {AuthContext} from '../../../../../../contexts/auth/context';
import {AuthContextType} from '../../../../../../contexts/auth/types';
import {ProfessionalCaregiverInviteFormType} from '../../../../../../enums/professional-caregiver-invite-form-type';

export default function InviteProfessionalCaregiverProfessionalCaregiverOfficeScreen() {
  // Get context
  const authContext: AuthContextType = useContext(AuthContext);

  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  let {url} = useRouteMatch();

  return (
    <ProfessionalCaregiverInviteForm
      // Give the lowest permissions if we can't find the type
      formType={
        authContext.state.session?.selectedAffiliation?.type === AffiliationType.Administrator
          ? ProfessionalCaregiverInviteFormType.ProfessionalCaregiver_Administrator
          : ProfessionalCaregiverInviteFormType.ProfessionalCaregiver_Manager
      }
      senderType={InviteSenderType.Entity}
      senderId={authContext.state.session?.selectedAffiliation?.entity.id || ''}
      entity={{
        entityId: authContext.state.session?.selectedAffiliation?.entity.id || '',
        entityName: authContext.state.session?.selectedAffiliation?.entity.name || '',
      }}
      redirectUrl={`${url.replace('/invite', '')}`}
      showExitButton={true}
      useSmallerTitle={false}
    />
  );
}
